import React from "react"
import { useTranslation } from "react-i18next"
import ApiConnectorCard from "../ApiConnectorCard"
import awsLogo from "assets/images/connectors/aws-logo.svg"

/**
 * AWS card for the developer portal
 * Redirects to AWS documentation for configuration
 */
const AWSCard = () => {
  const { t } = useTranslation()

  return (
    <ApiConnectorCard
      serviceName={t("developer_portal:connectors.aws.name")}
      description={t("developer_portal:connectors.aws.description")}
      tag={t("developer_portal:connectors.aws.tag")}
      documentationUrl={t("developer_portal:connectors.aws.documentation_url")}
      logoSource={awsLogo}
      logoAlt="AWS"
    />
  )
}

export default AWSCard
